import { Link } from 'react-router-dom'
import anchetas_2023 from '../../../img/galerias/bienestar_social/202312_anchetas/foto_1.jpg'
import anchetas_2024 from './202412_anchetas/foto_1.jpg'
import anchetas_2025 from './202512_anchetas/foto_1.jpg'
import deporte_2024 from './20240526_uniformes/foto_6.jpg'
import cultura_2024 from './202407_cultura/foto_5.jpg'
import vivienda_202604 from './202604_vivienda/foto_1.jpg'

export default function Index() {
  const temas = [
    {
      nombre: 'Labor social',
      imagen: vivienda_202604,
      texto: 'Construccíon de muro de contención',
      ruta: '/galeria/bienestar-social/vivienda-202604',
    }, 
    {
      nombre: 'Anchetas 2025',
      imagen: anchetas_2025,
      texto: 'Entrega de anchetas navideñas 2025',
      ruta: '/galeria/bienestar-social/anchetas-2025',
    }, 
    {
      nombre: 'Anchetas 2023',
      imagen: anchetas_2023,
      texto: 'Entrega de anchetas navideñas 2023',
      ruta: '/galeria/bienestar-social/anchetas-2023',
    },    
    {
      nombre: 'Anchetas 2024',
      imagen: anchetas_2024,
      texto: 'Entrega de anchetas navideñas 2024',
      ruta: '/galeria/bienestar-social/anchetas-2024',
    },    
    {
      nombre: 'Entrega uniformes',
      imagen: deporte_2024,
      texto: 'Entrega uniformes 2024',
      ruta: '/galeria/bienestar-social/deporte-2024',
    },    
    {
      nombre: 'Apoyo cultural',
      imagen: cultura_2024,
      texto: 'Festival del Chande',
      ruta: '/galeria/bienestar-social/cultura-2024',
    }
  ];

  return (
    <div className='container mt-4'>
      <div className='row justify-content-center'>
        <div className='pb-3 text-center'><h4>Galerias - Bienestar social</h4></div>
        <div className='border-top border-3 mb-3'></div>
        {temas.map((t, i) => (
          <div key={i} className='col-12 col-sm-6 col-md-4 col-lg-2 mb-4'>
            <Link to={t.ruta} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="card h-100">
                <img src={t.imagen} className="card-img-top" alt={t.nombre} />
                <div className="card-body">
                  <h6 className="fw-bold">{t.nombre}</h6>
                  <p className="card-text">{t.texto}</p>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
